export const SEC_03_CapabilityManagementValidator = (mapping) => {
    // Ensuring we don't send "Ghost" IDs to the nrgCore API
    const hasDivision = mapping.divisionCode && mapping.divisionCode.length > 0;
    const hasRole = mapping.roleId > 0;
    const hasCap = mapping.capabilityId > 0;

    return hasDivision && hasRole && hasCap;
};